import React from 'react';
import Icon from '../Icon'

export default function FemaleIcon({ title, fontSize }) {
    return (<Icon icon="businesswoman" title={title} style={{ color: "red", fontSize: fontSize || "16px", paddingRight: "4px" }} />);
};